module.exports = __webpack_public_path__ + "static/media/address-b.19280f9b.svg";